import React from "react";
import { Radio } from "rsuite";
import { constructMarkup } from "../../common/utils";

const AnnotatedRadio = ({value, label, annotation = () => null}) => {
    return (
        <>
            <Radio value={value}>{constructMarkup(label)}</Radio>
            {annotation()}
        </>
    )
}

export default AnnotatedRadio;